import {getId} from 'apis/model/base'
import classNames from 'classnames'
import getTitle from 'helpers/getTitle'
import useTranslate from 'modules/local/useTranslate'
import React, {useMemo, useState} from 'react'
import {GradeStudentReport} from 'views/AppLocals/Course/CourseClass/tabs/CourseClassGradeTab'

export const CourseClassGradingPanel = ({item}) => {
    const t = useTranslate()
    const course_class_id = getId(item)
    const classSubjects = useMemo(
        () => (item?.class_subjects ?? []).filter(cs => !!cs?.subject),
        [item]
    )
    const [selectedSubjectId, setSelectedSubjectId] = useState(
        () => String(getId(classSubjects[0]?.subject) ?? '') || null
    )
    const selectedCs = useMemo(
        () => classSubjects.find(cs => String(getId(cs.subject)) === String(selectedSubjectId)),
        [classSubjects, selectedSubjectId]
    )
    const passedScore = selectedCs?.passed_score ?? 0

    return (
        <div className="flex flex-col gap-3">
            {classSubjects.length > 0 && (
                <div className="flex flex-col gap-1.5">
                    <span className="text-color-300 tracking-wider">
                        {`${t('subjects')} :`}
                    </span>
                    <div className="flex flex-wrap gap-1.5">
                        {classSubjects.map((cs) => {
                            const sid = String(getId(cs.subject))
                            const isActive = sid === String(selectedSubjectId)
                            const ps = cs.passed_score
                            return (
                                <button
                                    key={sid}
                                    onClick={() => setSelectedSubjectId(sid)}
                                    className={classNames(
                                        'flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-full border transition-colors select-none',
                                        isActive
                                            ? 'bg-indigo-600 border-indigo-600 text-white'
                                            : 'border-color-200 text-color-300 hover:border-indigo-400 hover:text-indigo-500'
                                    )}>
                                    <span>{getTitle(cs.subject)}</span>
                                    {ps > 0 && (
                                        <span className={classNames('text-2xs font-normal', isActive ? 'text-indigo-200' : 'text-color-400')}>
                                            {`≥${ps}`}
                                        </span>
                                    )}
                                </button>
                            )
                        })}
                    </div>
                </div>
            )}
            <GradeStudentReport
                key={selectedSubjectId}
                course_class_id={course_class_id}
                activeSubjectId={selectedSubjectId}
                passedScore={passedScore}
            />
        </div>
    )
}
